/**
 * Base classes for the component.
 * @type {String}
 */
export const BASE_CLASSES = 'fit-checkbox';

/**
 * Theme supported shapes.
 * @type {Object<String>}
 */
export const SHAPES = {
    SQUARE: 'square',
    CIRCLE: 'circle'
};

/**
 * Theme supported colors.
 * @type {Object<String>}
 */
export const COLORS = {
    WHITE: 'white',
    GREEN: 'green',
    BLUE: 'blue'
};
